import React from "react";

import "./styles/layout.scoped.scss";

export default function Layout({ children }) {
    return <div className="layout">{children}</div>;
}
